module.exports = __webpack_public_path__ + "img/20190823165142QQ截图20190624162114.0ab24a31.png";